import { useCallback, useEffect, useState } from 'react';
import { ElementType, LayoutResponse } from './services/types';
import { getLayout } from './services/requests';
import Spinner from './components/Spinner/Spinner';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Authorize from './Authorize';
import Background from './components/Background';
import { DEFAULT_BACKGROUND, DEFAULT_FONT_COLOR } from './uiConstants';
import Title from './components/Title';
import './Authorize.css';

const App = () => {

  const [layout, setLayout] = useState<LayoutResponse[]>([]);
  const [loading, setLoading] = useState(true);
  const [showError, setShowError] = useState(false);

  const appTitle = layout.find(p => p.elementType === ElementType.APP_TITLE)?.elementHtml || '';
  const favicon = layout?.find(p => p.elementType === ElementType.FAVICON)?.elementHtml || undefined;
  const bgColor = layout.find(p => p.elementType === ElementType.BACKGROUND_COLOR)?.elementHtml || DEFAULT_BACKGROUND;

  const query = new URLSearchParams(window.location.search)
  const [wlp] = useState(query.get('name'));
  const [state] = useState(query.get('state'));
  const redirectUri = query.get('redirectUri');

  const redirectError = useCallback((error?: string) => {
    const options = { error: error || 'server_error' };
    const qs = new URLSearchParams(options).toString();

    if (redirectUri) {
      window.location.replace(`${redirectUri}?${qs}`);
    }
    else { setShowError(true) }
  }, [redirectUri]);

  useEffect(() => {
    const get = async (wlp: string) => {
      try {
        setLoading(true);
        const result = await getLayout(wlp);
        setLayout(result);
        setLoading(false);
      }
      catch (e) {
        console.log(e);
        setLoading(false);
      }
    };
    if (wlp) {
      get(wlp);
    }
  }, [wlp]);

  if (loading) return (<Background color={DEFAULT_BACKGROUND}>< Spinner /></Background>);
  return (
    <HelmetProvider>
      <Helmet>
        <title>{appTitle}</title>
        {favicon && <link rel="icon" type="image/png" href={`data:image/svg+xml;utf8,${encodeURIComponent(favicon)}`} sizes="16x16" />}
      </Helmet>
      <Background color={bgColor}>
        <header className="app-header">
          {showError ?
            <Title color={DEFAULT_FONT_COLOR}>Failed to start authorization</Title> :
            <Authorize layout={layout} onError={redirectError} state={state} redirectUri={redirectUri} />
          }
        </header>
      </Background>
    </HelmetProvider>
  );
}

export default App;
